import { render, staticRenderFns } from "./ContasPagarParceiros.vue?vue&type=template&id=cb84ca94&scoped=true&"
import script from "./ContasPagarParceiros.vue?vue&type=script&lang=js&"
export * from "./ContasPagarParceiros.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb84ca94",
  null
  
)

export default component.exports